/***************************************************************************************************
 * Load `$localize` - only needed if you use i18n
 */
// import '@angular/localize/init';

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';
